import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatErr } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { AuthShell } from "@/components/AuthShell";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [pw, setPw] = useState({ a: "", b: "" });
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (pw.a !== pw.b) return setErr("Passwords do not match");
    setErr("");
    try { await api.post("/auth/reset-password", { token: params.get("token") || "", new_password: pw.a }); setDone(true); }
    catch (e2) { setErr(formatErr(e2)); }
  };

  return (
    <AuthShell title="Reset password" subtitle="Choose a new password (min 6 characters)">
      {done ? (
        <p data-testid="reset-success" className="text-sm bg-emerald-50 border border-emerald-200 text-emerald-800 rounded-lg p-4">Password updated. You can sign in now.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <Input data-testid="reset-password-input" type="password" required minLength={6} placeholder="New password" value={pw.a} onChange={(e) => setPw({ ...pw, a: e.target.value })} />
          <Input data-testid="reset-confirm-input" type="password" required minLength={6} placeholder="Confirm password" value={pw.b} onChange={(e) => setPw({ ...pw, b: e.target.value })} />
          {err && <p data-testid="reset-error" className="text-sm text-red-600">{err}</p>}
          <Button data-testid="reset-submit-btn" className="w-full h-11 bg-sky-600 hover:bg-sky-700">Update password</Button>
        </form>
      )}
      <Link to="/login" data-testid="back-to-login-link" className="text-sm text-sky-700 hover:underline">Go to sign in</Link>
    </AuthShell>
  );
}
